import React from 'react';
import './header.styles.scss';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';

import { useTranslation } from 'react-i18next';

export const Header = () => {
  const { t } = useTranslation();

  return (
    <div className='header-content'>
      <div className='content-1'>
        <p className='text-style-1'>{t('header.title')}</p>
        <p className='text-style-2'>{t('header.subtitle')}</p>
      </div>
      <div className='content-2'>
        <p className='text-style-3'>{t('header.description')}</p>
      </div>
      <div className='header-button'>
        <button className='button-header_1'>
          <Link to='/solution/did' className='explore-button'>
            <p className='border-para_1'>{t('header.button1')}</p>
          </Link>
        </button>
        <button className='button-header_1'>
          <Link to='/apps' className='explore-button'>
            <p className='border-para_1'>{t('header.button2')}</p>
          </Link>
        </button>
      </div>
    </div>
  );
};

export const HeaderOverlap = props => {
  const { announcement } = props;

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,           // Enable autoplay
    autoplaySpeed: 3000,      // Set autoplay interval in milliseconds (e.g., 3000ms or 3s)
    arrows: false,
  };

  //const limitedAnnouncements = announcement.slice( -3);
// Get the last 3 announcements and reverse their order to show the latest first
const limitedAnnouncements = announcement.slice(-3).reverse();

  return (
    <Slider {...settings}>
      {limitedAnnouncements.map((announcement, index) => (
        <div key={index} className='overlap-content'>
          <div className='overlap-text'>
            <p className='overlap-text_1'>{announcement.title}</p>
            <p className='overlap-text_2'>{announcement.sub_title}</p>
            <p className='overlap-text_3'>{announcement.description}</p>
            <p className='overlap-text_3'><a href={announcement.url} className='overlap-text_3_link' target='_blank' rel="noreferrer">Read More...</a></p>
          </div>
          {/* <div className='overlap-btn'>
            <a className='overlap-btn_1' href={announcement.url} target='_blank' rel="noreferrer">Explore</a>
          </div> */}
        </div>
      ))}
    </Slider>
  );
}